import * as React from "react"
import * as ReactDOM from 'react-dom'
import App from './components/App'
import './less/styles.less'
import 'normalize.css'

ReactDOM.render(<App />, document.getElementById("app"))
